package games.polyclub.website.frontend.store

import games.polyclub.frontend.lib.react.simplified.SFC
import games.polyclub.website.frontend.store.components.Layout
import games.polyclub.website.frontend.store.components.PersistentLogin
import games.polyclub.website.frontend.store.components.RequireAuth
import games.polyclub.website.frontend.store.hooks.withTracker
import games.polyclub.website.frontend.store.pages.MissingPage
import games.polyclub.website.frontend.store.sitemap.LoggedSitemap
import games.polyclub.website.frontend.store.sitemap.PublicSitemap
import react.Props
import react.router.PathRoute
import react.router.Routes

val App = SFC<Props> {
    Routes {
        PathRoute {
            path = "/"
            Component = PersistentLogin
            PathRoute {
                path = LoggedSitemap.HOME.rootPath
                Component = RequireAuth
                PathRoute {
                    Component = Layout
                    LoggedSitemap.entries.forEach {
                        if (!it.isCustomLayout) {
                            it.component?.let { component ->
                                PathRoute {
                                    path = it.path
                                    Component = withTracker(component, it.title)
                                }
                            }
                        }
                    }
                }
                PathRoute {
                    LoggedSitemap.entries.forEach {
                        if (it.isCustomLayout) {
                            it.component?.let { component ->
                                PathRoute {
                                    path = it.path
                                    Component = withTracker(component, it.title)
                                }
                            }
                        }
                    }
                }
            }

            PathRoute {
                PublicSitemap.entries.forEach {
                    if (it.isCustomLayout) {
                        it.component?.let { component ->
                            PathRoute {
                                path = it.path
                                Component = withTracker(component, it.title)
                            }
                        }
                    }
                }
            }

            PathRoute {
                Component = Layout
                PublicSitemap.entries.forEach {
                    if (!it.isCustomLayout) {
                        it.component?.let { component ->
                            PathRoute {
                                path = it.path
                                Component = withTracker(component, it.title)
                            }
                        }
                    }
                }
            }

            PathRoute {
                Component = Layout
                PathRoute {
                    path = "*"
                    Component = MissingPage
                }
            }
        }
    }
}
